import component from "./Teachers";
export default component;
